import './TimeseriesTimeBottomAxisArea.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var timeBottomAxisContainer = _7a468({defaultClassName:'_4sfv3k0-2-0-1',variantClassNames:{isTouchableDevice:{true:'_4sfv3k1-2-0-1'}},defaultVariants:{},compoundVariants:[]});